import { httpRequest } from "@/lib";
import { CreateModelRequestDTO, RequestModelResponse } from "@/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

async function createModel(
  request: CreateModelRequestDTO
): Promise<RequestModelResponse> {
  const response = await httpRequest.post<RequestModelResponse>(
    "/models",
    request
  );
  return response.data;
}

export function useCreateModelMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createModel,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["models"] });
    },
  });
}
